<div class="page">

  <app-page-header page-title="searchDocs.title"></app-page-header>

  <div class="page-content">
    <mat-card class="custom-card card-no-border-bottom">
      <mat-card-header class="w-100">
        <mat-card-title>
          {{ 'searchDocs.subtitle' | translate }}
        </mat-card-title>
      </mat-card-header>

      <mat-card-content class="m-0">
        <div class="mb-2 text-right">
        </div>
        <mat-expansion-panel #filterPanel [expanded]="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger" matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="row mt-2">
            <div class="col-12 mb-2 text-right">
              <button mat-stroked-button color="primary" [disabled]="!someSelectedProperties" (click)="onResetAll()">{{ 'searchDocs.buttons.resetAll' | translate }}</button>
              <button mat-stroked-button class="mx-2" color="primary" [disabled]="!someSelectedProperties" (click)="onReset()">{{ 'searchDocs.buttons.reset' | translate }}</button>
              <button mat-raised-button color="primary" [disabled]="!someSelectedProperties" (click)="onSubmit()">{{ 'searchDocs.buttons.submit' | translate }}</button>
            </div>
          </div> 
          <div class="row mt-2">
            <!-- First col -->
            <div class="col-4 section" [ngClass]="{'active': step === 1}" (click)="OnSectionFocused(1)">
              <div class="row">
                <div class="col-12">
                  <div class="box m-2 p-2 active">
                    <div class="d-flex flex-row justify-content-between mb-2">
                      <div><strong>{{ 'searchDocs.fields.properties' | translate }}</strong></div>
                      <div><mat-icon fontSet="fal" fontIcon="fa-plus"></mat-icon></div>
                    </div>
                    
                    <div class="divider mb-2"></div>
                    <div [ngClass]="{'d-none': step > 1}">
                      <div class="subtitle mb-2" *ngIf="!loggedUserMaster">{{ 'searchDocs.fields.companiesSearch' | translate }}</div>
                      <app-company-search (eventCompanySelected)="OnCompanySelected($event)" *ngIf="!loggedUserMaster" #companySearch></app-company-search>
                      <div class="divider mb-2" *ngIf="!loggedUserMaster"></div>
                      <div>
                        <form class="form-property-search">
                          <div class="subtitle mb-1">{{ 'searchDocs.fields.nameSearch' | translate }}</div>
                          <mat-form-field class="form-field-full-width">
                            <!-- placeholder="{{ 'searchDocs.fields.nameSearch' | translate }}" -->
                            <input
                              matInput
                              class="input"

                              (keyup)="applyFilterProperties($event)"
                              [value]="propertySearchValue"
                            >
                          </mat-form-field>
                          <div class="subtitle mb-1">{{ 'searchDocs.fields.codeSearch' | translate }}</div>
                          <mat-form-field class="form-field-full-width">
                            <!-- placeholder="{{ 'searchDocs.fields.codeSearch' | translate }}" -->
                            <input
                              matInput
                              class="input"

                              (keyup)="applyFilterPropertyCode($event)"
                              [value]="propertyCodeSearchValue"
                            >
                          </mat-form-field>
                        </form>
                      </div>
                      <div class="divider mb-2"></div>
                      <div>
                        <mat-checkbox class="checkbox-insert" (change)="onSelectAllProperties($event.checked)"
                          [disabled]="!displayProperties || displayProperties && !displayProperties.length" color="primary" [checked]="selectAllProperties">
                          <strong>{{ 'common.cta.selectAll' | translate }}</strong>
                        </mat-checkbox>
                      </div>
                      <div class="divider mb-2"></div>

                      <div class="d-flex flex-row justify-content-center">
                      <mat-spinner diameter="50" [ngClass]="{'d-none': !propertiesIsLoading}"></mat-spinner>
                      </div>

                      <div class="properties-box" [ngClass]="{'d-none': propertiesIsLoading}">
                        <div *ngFor="let item of displayProperties; let i = index;">
                          <mat-checkbox [(ngModel)]="item.checked" class="checkbox-insert" color="primary" [checked]="selectAllProperties" (change)="onSelectProperty()">
                            {{ item.name }}
                          </mat-checkbox>
                        </div>
                      </div>
                    </div>
                    <div [ngClass]="{'d-none': step === 1}">
                      <div *ngFor="let item of displayProperties; let i = index;">
                        <mat-checkbox [(ngModel)]="item.checked" class="checkbox-insert" color="primary" *ngIf="item.checked">
                          {{ item.name }}
                        </mat-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Second col -->
            <div class="col-4 section" [ngClass]="{'active': step === 2}" (click)="OnSectionFocused(2)">
              <div class="row">
                <div class="col-12">
                  <div class="box m-2 p-2" [ngClass]="{'disabled': !someSelectedProperties, 'active': someSelectedProperties}">
                    <div class="mb-2"><strong>{{ 'searchDocs.fields.area' | translate }}</strong></div>
                    <mat-select [(ngModel)]="selectedArea" (selectionChange)="onChangeArea()" [disabled]="!someSelectedProperties">
                      <mat-option value="">{{ 'searchDocs.fields.selectArea' | translate }}</mat-option>
                      <mat-option *ngFor="let area of configService.availableDocumentAreas" [value]="area">
                        {{ 'properties.documents.areas.' + area | translate }}
                      </mat-option>
                    </mat-select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="box m-2 p-2" [ngClass]="{'disabled': selectedArea === '', 'active': selectedArea !== ''}">
                    <div class="mb-2"><strong>{{ 'searchDocs.fields.topic' | translate }}</strong></div>
                    <div class="divider mb-2"></div>
                    <div>
                      <mat-checkbox (change)="onSelectAllTopics($event.checked)"
                        [disabled]="selectedArea === ''" color="primary" [checked]="selectAllTopics">
                        <strong>{{ 'common.cta.selectAll' | translate }}</strong>
                      </mat-checkbox>
                    </div>
                    <div class="divider mb-2"></div>
                    <div *ngFor="let item of topics; let i = index;">
                      <mat-checkbox [(ngModel)]="item.checked" color="primary" [checked]="selectAllTopics" [disabled]="selectedArea === ''" (change)="onSelectTopic(item, $event.checked)">
                        {{ item.name }}
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="box m-2 p-2" [ngClass]="{'disabled': !someSelectedProperties, 'active': someSelectedProperties}">
                    <div class="mb-2"><strong>{{ 'searchDocs.fields.supplier' | translate }}</strong></div>
                    <app-supplier-search (eventSupplierSelected)="OnSupplierSelected($event)" #supplierSearch></app-supplier-search>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="box m-2 p-2" [ngClass]="{'disabled': !someSelectedProperties, 'active': someSelectedProperties}">
                    <div class="mb-2"><strong>{{ 'searchDocs.fields.date' | translate }}</strong></div>
                    <div class="row">
                      <div class="col-6">
                        <!-- placeholder="{{ 'searchDocs.fields.from' | translate }}" -->
                        <mat-form-field>
                          <input matInput [matDatepicker]="pickerFrom" [(ngModel)]="dateFrom" [disabled]="!someSelectedProperties">
                          <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                          <mat-datepicker #pickerFrom></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div class="col-6">
                        <!-- placeholder="{{ 'searchDocs.fields.to' | translate }}" -->
                        <mat-form-field>
                          <input matInput [matDatepicker]="pickerTo" [(ngModel)]="dateTo"  [disabled]="!someSelectedProperties">
                          <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                          <mat-datepicker #pickerTo></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="box m-2 p-2" [ngClass]="{'disabled': !someSelectedProperties, 'active': someSelectedProperties}">
                    <div class="mb-2"><strong>{{ 'searchDocs.fields.protocol' | translate }}</strong></div>
                    <mat-form-field class="form-field-full-width">
                      <!-- placeholder="{{ 'searchDocs.fields.enterProtocol' | translate }}" -->
                      <input 
                        matInput 
                        class="input"
                        
                        [disabled]="!someSelectedProperties"
                        [(ngModel)]="protocolValue"
                      >
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="box m-2 p-2" [ngClass]="{'disabled': !someSelectedProperties, 'active': someSelectedProperties}">
                    <div class="mb-2"><strong>{{ 'searchDocs.fields.keyword' | translate }}</strong></div>
                    <mat-form-field class="form-field-full-width">
                      <!-- placeholder="{{ 'searchDocs.fields.enterKeyword' | translate }}" -->
                      <input 
                        matInput 
                        class="input"
                        
                        [disabled]="!someSelectedProperties"
                        [(ngModel)]="keywordValue"
                      >
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <!-- third col -->
            <div class="col-4 section" [ngClass]="{'active': step === 3}" (click)="OnSectionFocused(3)">
              <div class="row">
                <div class="col-12">
                  <div class="box m-2 p-2" [ngClass]="{'disabled': !someSelectedTopics}">
                    <div class="mb-2"><strong>{{ 'searchDocs.fields.subtopic' | translate }}</strong></div>
                    <div class="divider mb-2"></div>
                    <div>
                      <mat-checkbox class="checkbox-insert" (change)="onSelectAllSubtopics($event.checked)"
                        [disabled]="!someSelectedTopics" color="primary" [checked]="selectAllSubtopics">
                        <strong>{{ 'common.cta.selectAll' | translate }}</strong>
                      </mat-checkbox>
                    </div>
                    <div class="divider mb-2"></div>
                    <div *ngFor="let topic of topics">
                      <div *ngIf="topic.checked">
                        <div class="subtitle"> {{ topic.name }}</div>
                        <div *ngFor="let item of subtopics; let i = index;">
                          <div *ngIf="item.parent === topic.code">
                            <mat-checkbox [(ngModel)]="item.checked" class="checkbox-insert" color="primary" [checked]="selectAllSubtopics" (change)="onSelectSubtopic(item, $event.checked)">
                              {{ item.name }}
                            </mat-checkbox>
                          </div>
                        </div>  
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mb-5">
                <div class="col-12">
                  <div class="box m-2 p-2" [ngClass]="{'disabled': !someSelectedTopics}">
                    <div class="mb-2"><strong>{{ 'searchDocs.fields.documents' | translate }}</strong></div>
                    <div class="divider mb-2"></div>
                    <div>
                      <mat-checkbox class="checkbox-insert" (change)="onSelectAllDocuments($event.checked)"
                        [disabled]="!someSelectedTopics" color="primary" [checked]="selectAllDocuments">
                        <strong>{{ 'common.cta.selectAll' | translate }}</strong>
                      </mat-checkbox>
                    </div>
                    <div>
                      <mat-checkbox class="checkbox-insert" (change)="onShowMandatoryDocuments($event.checked)"
                        [disabled]="!someSelectedTopics" color="primary" [checked]="selectMandatoryDocuments">
                        <strong>{{ 'searchDocs.mandatoryOnly' | translate }}</strong>
                      </mat-checkbox>
                    </div>
                    <div class="divider mb-2"></div>
                    <div>
                      <form class="form-property-search">
                        <div class="subtitle mb-1">{{ 'searchDocs.fields.docSearch' | translate }}</div>
                        <mat-form-field class="form-field-full-width">
                          <!-- placeholder="{{ 'searchDocs.fields.docSearch' | translate }}" -->
                          <input 
                            matInput 
                            class="input"
                            
                            (keyup)="applyFilterDocs($event)" 
                            [disabled]="!documents.length" 
                            [value]="docSearchValue"
                          >
                        </mat-form-field>
                      </form>
                    </div>
                    <div class="divider mb-2"></div>
                    <div *ngFor="let subtopic of subtopics">
                      <div *ngIf="subtopic.checked">
                        <div class="subtitle"> {{ subtopic.name }}</div>
                        <div *ngFor="let item of displayDocs; let i = index;">
                          <div *ngIf="item.parent === subtopic.code">
                            <div *ngIf="item.visible">
                              <mat-checkbox [(ngModel)]="item.checked" class="checkbox-insert" color="primary" (change)="onSelectDoc(item, $event.checked)" [checked]="selectAllDocuments">
                                <span [ngClass]="{'document-wrapper-text-mandatory-missing': item.mandatory || item.code === 'PA31' || item.code === 'PA32'}">{{ item.title }}</span>
                              </mat-checkbox>
                            </div>
                          </div>
                        </div>  
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style="position: absolute; bottom: 0;" class="d-flex justify-content-center w-100 mb-3">
                <button mat-raised-button class="w-75" color="primary" [disabled]="!someSelectedProperties" (click)="onSubmit()">{{ 'searchDocs.buttons.submit' | translate }}</button>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <mat-card class="card-no-border-bottom mt-4">
      <mat-card-header class="w-100">
        <mat-card-title>
            {{ 'searchDocs.resultTitle' | translate }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="row mt-2">
          <div class="col-12 mb-2 text-right">
            <button mat-stroked-button color="primary" class="mr-2" (click)="onExportToExcel()"
              [disabled]="!canExport">
              <mat-icon fontSet="fal" fontIcon="fa-file-export"></mat-icon>
              {{ 'common.export' | translate }}
            </button>
            <button *ngIf="!showDocumentsMandatory" mat-stroked-button color="primary" class="mr-2" (click)="onShowDocsMandatory()" [disabled]="!canExport">
              <mat-icon fontSet="fas" fontIcon="fa-eye"></mat-icon>
              {{ 'properties.documentsPage.showDocsMandatory' | translate }}
            </button>
            <button *ngIf="showDocumentsMandatory" mat-stroked-button color="primary" class="mr-2" (click)="onHideDocsMandatory()" [disabled]="!canExport">
              <mat-icon fontSet="fas" fontIcon="fa-eye-slash"></mat-icon>
              {{ 'properties.documentsPage.hideDocsMandatory' | translate }}
            </button>
            <button *ngIf="!showDocumentsExpired" mat-stroked-button color="primary" (click)="onShowDocsExpired()" [disabled]="!canExport">
              <mat-icon fontSet="fas" fontIcon="fa-eye"></mat-icon>
              {{ 'properties.documentsPage.showDocsExpired' | translate }}
            </button>
            <button *ngIf="showDocumentsExpired" mat-stroked-button color="primary" (click)="onHideDocsExpired()" [disabled]="!canExport">
              <mat-icon fontSet="fas" fontIcon="fa-eye-slash"></mat-icon>
              {{ 'properties.documentsPage.hideDocsExpired' | translate }}
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <app-card-spinner [visible]="resulIsLoading" type="zero"></app-card-spinner>
            <table mat-table matSort #sortTable="matSort" matSortActive="property" matSortDirection="asc" [dataSource]="dataSource" class="mat-elevation-z8">
              <ng-container matColumnDef="index">
                <th mat-header-cell *matHeaderCellDef> {{ 'searchDocs.resultFields.index' | translate }} </th>
                <td mat-cell *matCellDef="let element; let i = index"><span style="color: black !important;"> {{ i + 1 }} </span></td>
              </ng-container>
              <ng-container matColumnDef="property">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'searchDocs.resultFields.property' | translate }} </th>
                <td mat-cell *matCellDef="let element">
                  <div *ngIf="loggedUserMaster">{{ element.property }}</div>
                  <div *ngIf="!loggedUserMaster">
                    <a routerLink="../../properties/{{element.propertyId}}/home" target="_blank"> {{ element.property }}</a>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="masterCode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'searchDocs.resultFields.masterCode' | translate }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.masterCode || ('common.words.dashes' | translate) }} </td>
              </ng-container>
              <ng-container matColumnDef="docType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'searchDocs.resultFields.docType' | translate }} </th>
                <td mat-cell *matCellDef="let element"> 
                  {{ element.docType }} 
                  <div *ngIf="element.expired" class="document-expired">
                    {{ (element.privacy ? 'searchDocs.resultFields.tagSuperato' : 'searchDocs.resultFields.tagExpired') | translate}}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="structure">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'searchDocs.resultFields.structure' | translate }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.structure }} </td>
              </ng-container>
              <ng-container matColumnDef="content">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'searchDocs.resultFields.content' | translate }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.content }} </td>
              </ng-container>
              <ng-container matColumnDef="reference">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'searchDocs.resultFields.reference' | translate }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.reference }} </td>
              </ng-container>
              <ng-container matColumnDef="documentDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'searchDocs.resultFields.documentDate' | translate }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.documentDate ? (element.documentDate | dateDocumentFormat) : '---' }} </td>
              </ng-container>
              <ng-container matColumnDef="expirationDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'searchDocs.resultFields.expirationDate' | translate }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.expirationDate ? (element.expirationDate | dateDocumentFormat) : '---' }} </td>
              </ng-container>
              <ng-container matColumnDef="barCode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'searchDocs.resultFields.barCode' | translate }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.barCode }} </td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> {{ 'common.cta.actions' | translate }} </th>
                <td mat-cell *matCellDef="let element"> 
                  <button mat-icon-button [matMenuTriggerFor]="menu" color="primary">
                    <mat-icon fontSet="fas" fontIcon="fa-ellipsis-v"></mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <a mat-menu-item
                      style="text-decoration: none !important;"
                      *ngIf="!loggedUserMaster" 
                      routerLink="../../properties/{{element.propertyId}}/documents" 
                      target="_blank"> 
                      <mat-icon fontSet="fal" fontIcon="fa-folder" class="icon-action"></mat-icon>
                      {{ 'searchDocs.buttons.goToDocuments' | translate }}
                    </a>
                    <button mat-menu-item 
                      *ngIf="!loggedUserMaster && element.data"
                      (click)="onToggleEditShowDocument(element.documentArchiveId, element.docType, element.key, element.docId, element.subDocId, element.data, 'show', '', element.keyTranslateTitle, element.structureId, element.expired, element.pdfmsg, element.companyCode, element.propertyCode)">
                      <mat-icon fontSet="fal" fontIcon="fa-search" class="icon-action"></mat-icon>
                      {{ 'common.cta.viewAdditionalData' | translate }}
                    </button>
                    <button mat-menu-item
                      *ngIf="!loggedUserMaster && element.data && loggedUserPermissions.includes('canEditDocumentsData')"
                      (click)="onToggleEditShowDocument(element.documentArchiveId, element.docType, element.key, element.docId, element.subDocId, element.data, 'edit', '', element.keyTranslateTitle, element.structureId, element.expired, element.pdfmsg, element.companyCode, element.propertyCode)">
                      <mat-icon fontSet="fal" fontIcon="fa-pencil-alt" class="icon-action"></mat-icon>
                      {{ 'common.cta.editAdditionalData' | translate }}
                    </button>
                    <button mat-menu-item 
                      *ngIf="element.data && element.data.document&& element.data.document.length"
                      (click)="onDownloadDocument(element.propertyId, element.data.document)">
                      <mat-icon fontSet="fal" fontIcon="fa-download" class="icon-action"></mat-icon>
                      {{ 'common.cta.downloadFile' | translate }}
                    </button>
                    <button mat-menu-item
                      *ngIf="!loggedUserMaster && element.data && loggedUserPermissions.includes('canDeleteDocuments')"
                      (click)="onDeleteDocument(element)">
                      <mat-icon fontSet="fal" fontIcon="fa-trash" class="icon-action"></mat-icon>
                      {{ 'common.cta.deleteDoc' | translate }}
                    </button>
                    <button mat-menu-item
                      *ngIf="!loggedUserMaster && element.contract && !element.expired && element.data && loggedUserPermissions.includes('canDeleteDocuments')"
                      (click)="onCancelContractDialogOpen(element.documentArchiveId, element.propertyId, element.property, element.docType, element.data)">
                      <mat-icon fontSet="fal" fontIcon="fa-paper-plane" class="icon-action"></mat-icon>
                      {{ 'common.cta.cancellation' | translate }}
                    </button>
                    <button mat-menu-item
                      *ngIf="!loggedUserMaster && element.contract && !element.expired && element.data && loggedUserPermissions.includes('canDeleteDocuments')"
                      (click)="onHandleExpiredContract(element.documentArchiveId, element.data)">
                      <mat-icon fontSet="fal" fontIcon="fa-ban" class="icon-action"></mat-icon>
                      {{ 'common.cta.disableContract' | translate }}
                    </button>
                  </mat-menu>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr 
                mat-row 
                *matRowDef="let row; columns: displayedColumns;"
                [ngClass]="{'document-wrapper-text-mandatory-added': row.mandatory && !row.expired && helperService.isDocumentDataPopulated(row.data),
                    'document-wrapper-text-mandatory-missing': row.mandatory && !row.expired && !helperService.isDocumentDataPopulated(row.data),
                    'document-wrapper-text-not-mandatory': !row.mandatory || row.expired}"
              ></tr>
            </table>
            <div class="alert alert-warning my-3" role="alert"
              *ngIf="!dataSource || (dataSource && !dataSource.length)">
              {{ 'common.words.no_search_results' | translate }}
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
 </div>
</div>